export default "__VITE_ASSET__DhfRwjZY__"